<template lang="pug">
div.modal-wrapper
  div.modal(
    v-if="modalShown"
    @click.self="hideModal"
    tabindex="-1"
    role="dialog")
    div.modal-dialog(role="document")
      div.modal-content
        div.modal-header
          h5.modal-title {{ title }}
          button.close(
            v-if="userCanClose"
            @click="hideModal"
            aria-label="Close")
            span(aria-hidden="true") &times;
        div.modal-body
          p(v-html="message")
        div.modal-footer
          template(v-if="type === 'confirm'")
            button.btn.small.muted(@click="onCancel")
              template(v-if="cancelButtonText") {{ cancelButtonText }}
              template(v-else) Cancel changes
            button.btn.small(
              :class="[ confirmButtonClass ? confirmButtonClass : 'success' ]"
              @click="onConfirm")
              template(v-if="confirmButtonText") {{ confirmButtonText }}
              template(v-else) Save changes
          template(v-else)
            button.btn.small(@click="onInformConfirm")
              template(v-if="confirmButtonText") {{ confirmButtonText }}
              template(v-else) Ok
</template>

<script>
import modalSvc from '@/services/modalSvc.js';

export default {
  name: 'TheModal',
  data() {
    return {
      modalShown: false,
      title: null,
      message: null,
      type: null,
      onConfirm: null,
      onCancel: null,
      confirmButtonText: null,
      cancelButtonText: null,
      confirmButtonClass: null
    };
  },
  computed: {
    userCanClose() {
      return this.type !== 'confirm';
    }
  },
  methods: {
    init() {
      modalSvc.onShow(options => {
        this.resetModal();

        this.title = options.title;
        this.message = options.message;
        this.type = options.type;
        this.onConfirm = options.onConfirm;
        this.onCancel = options.onCancel;
        this.confirmButtonText = options.confirmButtonText;
        this.cancelButtonText = options.cancelButtonText;
        this.confirmButtonClass = options.confirmButtonClass;

        this.$root.$emit('block-body-scroll');
        this.modalShown = true;
      });

      modalSvc.onHide(() => {
        this.$root.$emit('unblock-body-scroll');
        this.modalShown = false;

        this.resetModal();
      });
    },
    resetModal() {
      this.title = null;
      this.message = null;
      this.type = null;
      this.onConfirm = null;
      this.onCancel = null;
      this.confirmButtonText = null;
      this.cancelButtonText = null;
      this.confirmButtonClass = null;
    },
    onInformConfirm() {
      if (this.onConfirm) {
        this.onConfirm();
      } else {
        modalSvc.hide();
      }
    },
    hideModal() {
      if (this.userCanClose) {
        modalSvc.hide();
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  background-color: red;

  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    outline: 0;
    background-color: rgba(0, 0, 0, 0.4);
  }
  .modal-dialog {
    max-width: 500px;
    margin: 28px auto;
    position: relative;
  }
  .modal-content {
    border-radius: 3px;
    width: 100%;
    background-color: #fff;
  }
  .modal-header {
    padding: 1rem;
    border-bottom: 1px solid $light-grey;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
    }
    .close {
      cursor: pointer;
    }
  }
  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;
  }
  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 1rem;
    border-top: 1px solid $light-grey;
  }
}
</style>
